import React, { useState, useEffect, useRef } from "react";
import {
  Form,
  Input,
  DatePicker,
  TimePicker,
  Button,
  Row,
  Alert,
  Select,
  Card,
} from "antd";
import { withRouter } from "react-router-dom";
import Connect from "../../../shared/redux/Connect.hoc";
import PlacesAutoComplete from "../../../shared/components/PlacesAutoComplete";
import swal from 'sweetalert';

import {
  createService,
  getCategorias,
} from "../../../helpers/Servicios.helper";
import { createNotification } from "../../../utils/utils";
import ToolBar from "../../../shared/components/ToolBar/ToolBar";
import Login from "../Login/Login.component";
import Signin from "../Signin/Signin.component";
import RecoverPass from "../RecoverPass/RecoverPass.component";
import './styles.scss';
const CreateServicio = ({ history, state }) => {
  const { Option } = Select;
  const [address, setAddress] = useState("");
  const [dateFields, setDateFields] = useState({
    dateService: "",
    timeService: "",
  });
  const [selectCategory, setSelectCategory] = useState([]);
  const [placeAddress, setPlaceAddress] = useState(true);
  const [stateUser, setStateUser] = useState(false);
  const [modalsFlags, setModalsFlags] = useState({
    login: false,
    signin: false,
    recoverPass: false,
  });
  const refForm = useRef();

  const toolBarLogin = () => {
    console.log(" --CreateMensajeria.Componente.toolBarLogin--  ");
    setModalsFlags({ recoverPass: false, login: true, signin: false });
  };
  const toolBarSignin = () => {
    console.log(" --CreateMensajeria.Componente.toolBarLogin--  ");
    setModalsFlags({ recoverPass: false, login: false, signin: true });
  };
  const [actionProgress, setActionProgress] = useState(false);

  const handleService = async (value) => {
    try {
      const body = {
        id_cliente: state.auth.user._id,
        changeStatus: "Servicio generado por el cliente",
        fecha_servicio: dateFields.dateService,
        hora_servicio: dateFields.timeService,
        id_categoria: value.service,
        lat: address.lat,
        lng: address.lng,
        nameLocation: address.place,
        addressLocation: address.place,
      };
      setActionProgress(true);
      const response = await createService(body);
      if (!response["ok"]) {
        swal({
          title: "Problemas generando Servicio",
          text: response["message"],
          icon: "error",
          button: "Reintentar",
        })
        // createNotification(response["message"], "error");
      } else {
        swal({
          title: "Servicio Generado",
          icon: "success",
          button: "Ver",
        })
        // createNotification("Servicio Registrado", "success");
        setActionProgress(false);

        history.push("/misservicios");
      }
    } catch (error) {
      throw error;
    }
  };
  const category = async () => {
    try {
      const category = await getCategorias();
      if (!category.ok) {
        createNotification("Error cargando categorias", "error");
      } else {
        setSelectCategory(category["finCate"]);
      }
    } catch (error) {
      throw error;
    }
  };

  useEffect(() => {
    setStateUser(state.auth.token ? true : false);
    category();
  }, []);
  return (
    <>
    <div className="Create-Div">
      <Row className="Create-Div-container" justify="center">
        <Card className="Create-Div-container-Card">
      <h4 style= {{color:'white', paddingBottom:'20px', fontFamily: 'Montserrat'}}>Solicitar un Servicio </h4>
          <Form onFinish={handleService} ref={refForm} layout='vertical'>
            <Form.Item
              label={<label style={{ color: "white" }}>Servicio de </label>}
              name="service"
              
              rules={[
                {
                  required: true,
                  message: "Seleccione el servicio a contratar",
                },
              ]}
              
            >
 
              <select style={{ width: "100%", height: "30px" , background:'white', borderRadius : '20px', border: 'medium',color: 'grey'}} >
              <option selected hidden value=''>Seleccione</option>
              {selectCategory.map((e) => {
                  return <option value={e._id}>{e.nameCategory}</option>;
                })}
              </select>
              {/* <Select placeholder="Seleccione" 
              style = {{borderRadius: '0px 8px 8px 0px'}}
              
              >
                {selectCategory.map((e) => {
                  return <Option value={e._id}>{e.nameCategory}</Option>;
                })}
              </Select> */}
            </Form.Item>
            <Form.Item
              label= {<label style={{ color: "white" }}>Dirección</label>}
              
              name="address"
              style = {{borderRadius: '20px'}}
              rules={[
                {
                  required: placeAddress,
                },
              ]}
            >
              <PlacesAutoComplete
              style = {{borderRadius: '20px',width:'100%'}}
                flag={setPlaceAddress}
                distancia={address}
                setDistancia={setAddress}
                
              />
            </Form.Item>

            <Form.Item
              label={<label style={{ color: "white" }}>Fecha del servicio</label>}
              
              
              name="dateService"
              rules={[
                { required: true, message: "Ingrese la fecha del servicio" },
              ]}
              
            >
              <DatePicker
                placeholder="Seleccione la fecha"
                style={{ width: "100%", height: "140%", borderRadius :'20px'}}
                onChange={(value, dateString) =>
                  setDateFields({ ...dateFields, dateService: dateString })
                }
              />
            </Form.Item>
            <Form.Item
            label={<label style={{ color: "white" }}>Hora del Servico</label>}
              name="timeService"
              rules={[
                { required: true, message: "Ingrese la hora del servicio" },
              ]}
            >
              <TimePicker
                use12Hours
                format="h:mm A"
                style={{ width: "100%", height: "140%" , borderRadius : '20px'}}
                placeholder="Seleccione la hora"
                onChange={(value, dateString) =>
                  setDateFields({ ...dateFields, timeService: dateString })
                }
              />
            </Form.Item>
            <Form.Item >
              <Button style={{ marginTop:'10px', width: "100%", height: "140%" , borderRadius : '20px', background: '#2994CD'}} htmlType="submit" disabled={!stateUser || actionProgress}>
                <div style= {{color:'white', font:'Montserrat'}}>Solicitar</div>
              </Button>
            </Form.Item>
          </Form>
        </Card>
      </Row>
      {modalsFlags.login && (
        <Login
          visibleLogin={modalsFlags.login}
          onCloseLogin={() => setModalsFlags({ ...modalsFlags, login: false })}
          onOpenSignin={() => setModalsFlags({ ...modalsFlags, login: true })}
          onOpenForgotePass={() =>
            setModalsFlags({ ...modalsFlags, recoverPass: true, login: false })
          }
        />
      )}
      {modalsFlags.signin && (
        <Signin
          visibleSignin={modalsFlags.signin}
          onCloseSignin={() =>
            setModalsFlags({ ...modalsFlags, signin: false })
          }
          onSignin={() => setModalsFlags({ ...modalsFlags, signin: true })}
        />
      )}
      {modalsFlags.recoverPass && (
        <RecoverPass
          visibleForget={modalsFlags.recoverPass}
          onCloseForget={() =>
            setModalsFlags({ ...modalsFlags, recoverPass: false })
          }
          onRecover={() =>
            setModalsFlags({ ...modalsFlags, recoverPass: true })
          }
        />
      )}
      </div>
    </>
  );
};

export default withRouter(Connect(CreateServicio));
